import { render, staticRenderFns } from "./SelfRegFeeList.vue?vue&type=template&id=18ae57ee&scoped=true&"
import script from "./SelfRegFeeList.vue?vue&type=script&lang=js&"
export * from "./SelfRegFeeList.vue?vue&type=script&lang=js&"
import style0 from "./SelfRegFeeList.vue?vue&type=style&index=0&id=18ae57ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae57ee",
  null
  
)

export default component.exports